export const CART_EXPIRATION = 4320; // 3 days (in minutes)
export const CART_COOKIE = 'cartId';
